import React from 'react';

export default function LeaveBalanceCard({ balances = [], employeeName = '' }) {
  return (
    <div className="rounded-2xl border border-outline-variant/25 bg-surface-container-lowest overflow-hidden shadow-xs">
      {/* Card Header matching Screenshot 3 */}
      <div className="flex items-center justify-between border-b border-outline-variant/20 bg-surface-container-low/60 px-5 py-3">
        <div className="flex items-center gap-2">
          <span className="material-symbols-outlined text-base text-primary">account_balance_wallet</span>
          <h3 className="text-xs font-bold text-on-surface">Leave Balance</h3>
        </div>
        {employeeName && (
          <span className="text-[11px] font-semibold text-on-surface-variant truncate max-w-[140px]">
            {employeeName}
          </span>
        )}
      </div>

      {/* Table matching Screenshot 3 */}
      {balances.length === 0 ? (
        <div className="p-6 text-center text-xs text-on-surface-variant">
          <p>No balance records available. Select an employee to view quotas.</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-left text-xs">
            <thead>
              <tr className="border-b border-outline-variant/15 bg-surface-container-low/30 text-[10px] font-bold uppercase tracking-wider text-on-surface-variant">
                <th className="px-4 py-2.5">Leave Type</th>
                <th className="px-4 py-2.5 text-right">Quota</th>
                <th className="px-4 py-2.5 text-right">Consumed</th>
                <th className="px-4 py-2.5 text-right">Balance</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-outline-variant/10">
              {balances.map((b, idx) => {
                const name = b.leave_type_name || b.leaveType || 'Leave';
                const alias = b.alias || b.leave_type_alias || '';
                const color = b.color || b.leave_type_color || '#3B82F6';
                const op = Number(b.op_balance ?? b.opBalance ?? 0);
                const consumed = Number(b.consumed ?? b.consume ?? 0);
                const current = Number(b.current_balance ?? b.currentBalance ?? 0);

                return (
                  <tr key={b.leave_type_id || idx} className="hover:bg-surface-container-low/40 transition-colors">
                    <td className="px-4 py-2.5 font-semibold text-on-surface">
                      <div className="flex items-center gap-2">
                        <span
                          className="h-2.5 w-2.5 shrink-0 rounded-full border border-black/10"
                          style={{ backgroundColor: color }}
                        />
                        <span>{name}</span>
                        {alias && (
                          <span className="rounded bg-surface-container-high px-1 py-0.2 text-[9px] font-bold text-on-surface-variant">
                            {alias}
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="px-4 py-2.5 text-right text-on-surface-variant font-medium">
                      {op.toFixed(2)}
                    </td>
                    <td className="px-4 py-2.5 text-right text-on-surface-variant font-medium">
                      {consumed.toFixed(2)}
                    </td>
                    <td className="px-4 py-2.5 text-right font-bold text-primary">
                      {current.toFixed(2)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
